import instanceAxios from '../config/api'
import { Comment, CommentsResponse } from '../types/commentTypes'

const API_URL = '/commentaires'

export const deleteCommentApi = async (_id: string) => {
  try {
    const response = await instanceAxios.delete<Comment[]>(`${API_URL}/` + _id)
    return response.data
  } catch (error: any) {
    console.error(error.message)
  }
}

export const addCommentApi = async (newComment: Comment): Promise<Comment> => {
  try {
    const response = await instanceAxios.post<Comment>(`${API_URL}`, newComment)
    return response.data
  } catch (error) {
    throw new Error('Failed to addComment.')
  }
}

export const getCommentbyIdApi = async (CommentId: string) => {
  try {
    const response = await instanceAxios.get<Comment>(`${API_URL}/` + CommentId)
    return response.data
  } catch (error) {
    throw new Error('Failed to fetchcomments.')
  }
}

export const updateCommentApi = async (
  updatedComment: Comment,
  _id: string
): Promise<Comment> => {
  try {
    const response = await instanceAxios.put<Comment>(
      `${API_URL}/${_id}`,
      updatedComment
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to PUTComment.')
  }
}

export const getCommentByActionIdApi = async (ActionId: string) => {
  try {
    const response = await instanceAxios.get<CommentsResponse>(
      `actions/getCommentaires/` + ActionId
    )
    return response
  } catch (error) {
    throw new Error('Failed to fetchcommentss.')
  }
}
